import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PurchaseInvoiceForm } from "@/features/purchase-invoices";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreatePurchaseInvoice = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { buyerId, ...payload } = formData;

      await apiOutletClient.post("purchase-invoices", payload, {
        headers: {
          "Outlet-Id": buyerId,
        },
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat faktur pembelian"));

      throw error;
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Faktur Pembelian"
      breadcrumbs={[
        { title: "Faktur Pembelian", path: "/procurement/purchase-invoices" },
        { title: "Tambah" },
      ]}
    >
      <PurchaseInvoiceForm
        onSubmit={handleSubmit}
        defaultValues={{
          buyer: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
